import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS, MomentDateAdapter } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MY_FORMATS } from '../filter-my-orders/filter-my-orders.component';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import dayjs from 'dayjs';
import { OrderStatusModel } from 'src/app/order-to-cash/models-otc/order-status-model';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup } from '@angular/forms';
import { ItemService } from 'src/app/order-to-cash/services-otc/item.service';
import { PlantsModel } from 'src/app/order-to-cash/models-otc/plants-model';
import { OrderManagerService } from 'src/app/order-to-cash/services-otc/order-manager.service';
import { AgentModel } from 'src/app/order-to-cash/models-otc/agent-model';
import { MetadataService } from 'src/app/order-to-cash/services-otc/metadata.service';
import { TermsModel } from 'src/app/order-to-cash/models-otc/terms-model';
import { User } from 'src/app/models/user';
import { Role } from 'src/app/models/role';

@Component({
  selector: 'app-download-report-dialog',
  templateUrl: './download-report-dialog.component.html',
  providers: [
    {
        provide: DateAdapter,
        useClass: MomentDateAdapter,
        deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS }
  ],
  encapsulation: ViewEncapsulation.None,
  styleUrl: './download-report-dialog.component.css',
  standalone: false
})
export class DownloadReportDialogComponent implements OnInit {
  statusList: OrderStatusModel[] = [];
  filteredStatusList: OrderStatusModel[] = [];
  agentList: AgentModel[] = [];
  filterAgentList: AgentModel[] = [];
  createdByList: User[] = [];
  filterCreatedByList: User[] = [];
  plantList: PlantsModel[] = [];
  filteredPlantList: PlantsModel[] = [];
  paymentTermsList: TermsModel[] = [];
  filteredTermsList: TermsModel[] = [];
  userRoles: Role[] = JSON.parse(sessionStorage.getItem('roles'));
  user: User = JSON.parse(sessionStorage.getItem('user'));
  otcRole: string = '';

  reportForm = new FormGroup({
    from: new FormControl(null),
    to: new FormControl(null),
    status: new FormControl(0),
    agent: new FormControl(0),
    createdByUser: new FormControl(0),
    plnt: new FormControl(0),
    payT: new FormControl(0),
    kbnum: new FormControl(null),
    soldTo: new FormControl(null),
    soldToDesc: new FormControl(null),
    payer: new FormControl(null),
    payerDesc: new FormControl(null),
    materialDesc: new FormControl(null),
    coOpNo: new FormControl(null),
  });
  agentFilterCtrl: FormControl = new FormControl();
  createdByFilterCtrl: FormControl = new FormControl();
  statusFilterCtrl: FormControl = new FormControl();
  termsFilterCtrl: FormControl = new FormControl();
  plantFilterCtrl: FormControl = new FormControl();

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<DownloadReportDialogComponent>,
    private orderManagerService: OrderManagerService,
    private itemService: ItemService,
    private metaDataService: MetadataService
  ) {}

  ngOnInit(): void {
    this.plantList = this.data?.plantList;
    this.filteredPlantList = [...this.plantList];
    for(let role of this.userRoles) {
      console.log(role.description);
      if(role.name === 'OTCOverallApprovingManager') {
        this.otcRole = 'admin';
      } else if(role.name === 'OTCAgent') {
        this.otcRole = 'agent';
      } else if(role.name === 'OTCApprovingManager') {
        this.otcRole = 'approver';
      } else {
        this.otcRole = 'rep';
      }
    }

    if(this.otcRole === 'agent' || this.otcRole === 'rep') {
      this.reportForm.removeControl('createdByUser');

      if(this.otcRole === 'agent') {
        this.reportForm.removeControl('agent');
      }
    }

    console.log(this.otcRole);

    if(this.otcRole !== 'agent') {
      this.populateAgentList();

      this.agentFilterCtrl.valueChanges.subscribe({
        next: res => {
          this.filterAgentList = [...this.agentList.filter(c => c?.user?.name?.toLowerCase().includes(res.toLowerCase()) || c?.user?.surname?.toLowerCase().includes(res.toLowerCase()))];
        }
      });

      this.createdByFilterCtrl.valueChanges.subscribe({
        next: res => {
          this.filterCreatedByList = [...this.createdByList.filter(c => c?.name?.toLowerCase().includes(res.toLowerCase()) || c?.surname?.toLowerCase().includes(res.toLowerCase()))];
        }
      });

      this.statusFilterCtrl.valueChanges.subscribe({
        next: res => {
          this.filteredStatusList = [...this.statusList.filter(c => c?.description?.toLowerCase().includes(res.toLowerCase()))];
        }
      });

      this.plantFilterCtrl.valueChanges.subscribe({
        next: res => {
          this.filteredPlantList = [...this.plantList.filter(c => c?.name?.toLowerCase().includes(res.toLowerCase()) || c?.plantCode?.toLowerCase().includes(res.toLowerCase()))];
        }
      });

      this.termsFilterCtrl.valueChanges.subscribe({
        next: res => {
          this.filteredTermsList = [...this.paymentTermsList.filter(c => c?.description?.toLowerCase().includes(res.toLowerCase()))];
        }
      });

      if(this.otcRole !== 'rep') {
        this.populateCreatedByUsers();
      }
    }

    this.populateOrderStatusList();
    this.populatePaymentTermList();
  }

  populatePaymentTermList() {
    this.metaDataService.getTermsList().subscribe({
      next: (response) => {
        this.paymentTermsList = response;
        this.filteredTermsList = [...this.paymentTermsList];
      }
    } )
  }

  populateOrderStatusList() {
    this.orderManagerService.getOrderStatusList().subscribe({
      next: (response) => {
        this.statusList = response;
        this.filteredStatusList = [...this.statusList];
      }
    });
  }

  populateAgentList() {
    if(this.otcRole === 'admin') {
      this.itemService.getOtcAgents().subscribe({
        next: (response) => {
          this.agentList = response;
          this.filterAgentList = [...this.agentList];
        }
      });
    } else {
      this.itemService.getOtcAgentsForOthers(this.user.id).subscribe({
        next: (response) => {
          this.agentList = response;
          this.filterAgentList = [...this.agentList];
        }
      });
    }
  }

  populateCreatedByUsers() {
    this.itemService.getCreatedByUsers(this.otcRole === 'approver' ? this.user.id : null).subscribe({
      next: (response) => {
        this.createdByList = response;
        this.filterCreatedByList = [...this.createdByList];
      }
    });
  }

  setFilterStartDate(event: MatDatepickerInputEvent<Date>): void {
    this.reportForm.get('from').setValue(event.target?.value ? dayjs(new Date(event.target?.value)).format('YYYY-MM-DD') : '');
  }

  setFilterEndDate(event: MatDatepickerInputEvent<Date>): void {
    this.reportForm.get('to').setValue(event.target?.value ? dayjs(new Date(event.target?.value)).format('YYYY-MM-DD') : '');
  }

  closeDialog(downloadDocument: boolean) {
    // this.reportForm.get('to').setValue('2026-01-23T07:20:21.264Z');
    // this.reportForm.get('from').setValue('2026-01-23T07:20:21.264Z');
    this.dialogRef.close(downloadDocument ? this.reportForm.value : null);
  }

}
